import React from 'react';

import { FormControl, Box, FormHelperText, TextField } from '@mui/material';

export default function InvestorDetailsDependentsField({
  value,
  error,
  setValue,
  setError,
}) {
  const handleChange = (event) => {
    const { value: newValue } = event.target;

    setValue(newValue);
    if (newValue !== '' && !Number.isInteger(Number(newValue))) {
      setError('Dependents must be an integer');
    } else {
      setError(false);
    }
  };

  return (
    <Box>
      <FormControl fullWidth>
        <TextField
          label='Number of Dependents'
          id='dependents'
          aria-describedby='dependents-helper-text'
          onChange={handleChange}
          error={Boolean(error || value === '')}
          value={value}
          variant='standard'
        />
        {error ? (
          <FormHelperText id='phone-helper-text'>{error}</FormHelperText>
        ) : (
          <FormHelperText id='phone-helper-text'>
            A dependent is a child or relative that you financially support.
          </FormHelperText>
        )}
      </FormControl>
    </Box>
  );
}
